import { RELATIONSHIP_BASE_URL } from 'config';

const logout = () => {
  window.location.href = `${RELATIONSHIP_BASE_URL}/logout`;
};

export default logout;
